import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Locked from './icon-lock.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Locked {...validProps} />;
}
SvgComponent.iconName = 'locked';

export const LockedIcon = svgIconWrapper(SvgComponent);
